import { render } from "./FutureRewards.vue?vue&type=template&id=74abdf84"
import script from "./FutureRewards.vue?vue&type=script&lang=js"
export * from "./FutureRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__